import { createSlice } from '@reduxjs/toolkit';
import { IModal, byId } from '@qodly/shared';
import {
  ICloseModalAction,
  ICreateModalAction,
  IEditModalAction,
  IRemoveModalAction,
} from './types';

export interface IModalsState {
  list: IModal[];
}

const initialState: IModalsState = {
  list: [],
};

const removeModalById = (state: IModalsState, id: string) => {
  return state.list.filter((modal) => modal.id !== id);
};

const stateSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    createModal: (state, action: ICreateModalAction) => {
      state.list.push(action.payload);
    },
    editModal: (state, action: IEditModalAction) => {
      const { id, ...payload } = action.payload;
      const found = state.list.find(byId(id));

      if (!found) return;

      Object.assign(found, {
        ...payload,
      });
    },
    removeModal: (state, action: IRemoveModalAction) => {
      const id = action.payload;
      state.list = removeModalById(state, id);
    },
    closeModal: (state, action: ICloseModalAction) => {
      const { id, reason } = action.payload;
      if (reason) {
        const found = state.list.find((modal) => modal.id === id);
        if (found) {
          found.closeReason = reason;
          found.isOpen = false;
        }
      } else {
        state.list = removeModalById(state, id);
      }
    },
  },
});

export const { createModal, removeModal, closeModal, editModal } =
  stateSlice.actions;

export default stateSlice;
